import { useEffect, useState } from "react";
import {
  getRuntimeConfig,
  type RuntimeMediaDelivery,
} from "../utils/runtimeConfig";

export const useRuntimeMediaDelivery = (): RuntimeMediaDelivery | null => {
  const [delivery, setDelivery] = useState<RuntimeMediaDelivery | null>(null);

  useEffect(() => {
    let active = true;
    void getRuntimeConfig().then((config) => {
      if (active) setDelivery(config.mediaDelivery);
    });
    return () => {
      active = false;
    };
  }, []);

  return delivery;
};
